import * as React from 'react';
import { MobilePreviewState, PreviewMode, MobilePreviewProps } from './MobilePreview.type';
import { MobilePreviewService } from './MobilePreview.service';

export const useMobilePreview = (props: MobilePreviewProps) => {
  const [state, setState] = React.useState<MobilePreviewState>({
    mode: 'both',
    isVisible: false,
    currentImage: null
  });

  // Detecta o modo ideal baseado no arquivo
  React.useEffect(() => {
    const optimalMode = MobilePreviewService.detectOptimalMode(props.file);
    const currentImage = MobilePreviewService.formatFileForPreview(
      props.file, 
      props.mediaType, 
      props.title, 
      props.description
    );

    setState(prev => ({
      ...prev,
      mode: optimalMode,
      currentImage
    }));
  }, [props.file, props.mediaType, props.title, props.description]);

  // Função para alternar visibilidade do preview
  const togglePreview = React.useCallback(() => {
    setState(prev => ({
      ...prev,
      isVisible: !prev.isVisible
    }));
  }, []);

  // Função para mudar o modo de preview
  const changeMode = React.useCallback((mode: PreviewMode) => {
    setState(prev => ({
      ...prev,
      mode
    }));
  }, []);

  // Verifica se deve mostrar o preview
  const shouldShowPreview = React.useMemo(() => {
    return MobilePreviewService.isValidForMobilePreview(props.file, props.mediaType);
  }, [props.file, props.mediaType]);

  // Gera dados de exemplo com a imagem atual
  const sampleCourses = React.useMemo(() => {
    if (!state.currentImage) return [];
    return MobilePreviewService.generateSampleCourses(state.currentImage);
  }, [state.currentImage]);

  // Função para obter título do modo atual
  const getModeTitle = React.useCallback(() => {
    switch (state.mode) {
      case 'poster':
        return 'Preview Poster (2:3)';
      case 'cover':
        return 'Preview Cover (16:9)';
      case 'both':
        return 'Preview Completo';
      default:
        return 'Preview Mobile';
    }
  }, [state.mode]);

  return {
    // Estado
    mode: state.mode,
    isVisible: state.isVisible,
    currentImage: state.currentImage,
    
    // Dados computados
    shouldShowPreview,
    sampleCourses,
    modeTitle: getModeTitle(),
    
    // Ações
    togglePreview,
    changeMode
  };
};
